import React from "react";

/**
 * Fängt JavaScript-Fehler beim Rendern ab. Ohne das hier führt JEDER unerwartete Fehler
 * irgendwo auf der Seite (z.B. kaputte/fehlende Daten) zu einem komplett weißen Bildschirm
 * für den Gast - mit der ErrorBoundary sieht er stattdessen eine freundliche Meldung statt
 * einer leeren Seite, und der Rest der Seite (Navbar etc.) kann weiter funktionieren.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "60vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", textAlign: "center",
          padding: "24px", fontFamily: "Inter, sans-serif",
        }}>
          <h1 style={{ fontSize: "22px", fontWeight: 600, marginBottom: "12px", color: "#13160F" }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ color: "#6E6A5E", fontSize: "14px", marginBottom: "24px", maxWidth: "360px" }}>
            Es ist ein unerwarteter Fehler aufgetreten. Bitte laden Sie die Seite neu.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "12px 28px", borderRadius: "999px", border: "none",
              background: "#1F3A2E", color: "white", fontWeight: 600,
              fontSize: "14px", cursor: "pointer",
            }}>
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
